import { createContext, useContext } from 'react'
import { useCmsBlocks } from '../../hooks/cms/useCmsBlocks'
import { name as laggySwrMiddlewareName } from '../../stale-while-revalidate/middlewares/laggy'
import { useConfig } from '../config'

const NotifyMessageContext = createContext()

const NotifyMessageProvider = ({ children }) => {
	const {
		notifyMessage: { cmsBlockIdentifier, cmsBlockIdentifierAdditionalContent, enabled },
	} = useConfig()

	const { blocks } = useCmsBlocks({
		identifiers: [cmsBlockIdentifier, cmsBlockIdentifierAdditionalContent],
		paused: !enabled || !(cmsBlockIdentifier && cmsBlockIdentifierAdditionalContent),
		options: { bhUse: [laggySwrMiddlewareName] },
	})

	return <NotifyMessageContext.Provider value={blocks}>{children}</NotifyMessageContext.Provider>
}

export default NotifyMessageProvider
export const useNotifyMessage = () => useContext(NotifyMessageContext)
